import React from 'react'
import PropTypes from 'prop-types'
import { ButtonGroup, Column, Columns, Container } from '@resurs/midas-react'
import { midas } from '@resurs/midas'

import { Select } from '../../midasComponents'

import Page from '../../internal/Page'
import LoaderOverlay from '../../internal/LoaderOverlay'
import PageActionBar from '../../internal/PageActionBar'
import { getText } from '../../internal/TextLabels'
import pageableTable from '../../higher-order/pageable-table'
import searchableTable from '../../higher-order/searchable-table'
import { OngoingPaymentHeaders } from '../../models/payments'
import OngoingPaymentsTable from './OngoingPaymentsTable'
import { ALL, PaymentStatusFilter } from './constants'

import styles from './OngoingPayments.module.scss'
import { usePagination } from '../../provider/PaginationProvider'
import { ChainTypes } from '../../models/chainTypes'

const OngoingPaymentsUI = props => {
  const { paginationData } = usePagination()
  const headers = OngoingPaymentHeaders(
    props.delayedPaymentAutomaticDebitDateEnabled,
  )

  const handleUpdateClick = () => {
    props.loadTransactions()
  }

  return (
    <Page title={getText('ongoingPayments.title')} dataCy="transactions-page">
      <PageActionBar
        items={
          <div className={styles.pageActionBarStyles}>
            <Select
              onChange={props.onStatusFilter}
              id="filter-transactions"
              value={paginationData.filters['status']}
              values={[
                {
                  key: ALL,
                  value: ALL,
                  valueLabel: getText('transactions.filter.showAll'),
                },
                {
                  key: PaymentStatusFilter.DEBITABLE,
                  value: PaymentStatusFilter.DEBITABLE,
                  valueLabel: getText('transactions.filter.debitable'),
                },
                {
                  key: PaymentStatusFilter.UNSIGNED,
                  value: PaymentStatusFilter.UNSIGNED,
                  valueLabel: getText('transactions.filter.unsigned'),
                },
              ]}
            />
            {props.chainType === ChainTypes.SINGLE_OWNER && (
              <>
                <span style={{ padding: '0.4rem' }} />
                <Select
                  onChange={props.onStoreFilter}
                  id="filter-transactions-store"
                  value={paginationData.filters['storeId']}
                  values={[
                    {
                      key: ALL,
                      value: ALL,
                      valueLabel: getText('transactions.filter.showAll'),
                    },
                    ...props.stores.map(
                      ({ id, tradeName, accountSystemStoreId }) => ({
                        key: id,
                        value: id,
                        valueLabel: `${tradeName} (${accountSystemStoreId})`,
                      }),
                    ),
                  ]}
                />
              </>
            )}
          </div>
        }
        actions={
          <ButtonGroup spacing>
            <button
              type="button"
              onClick={handleUpdateClick}
              className={[midas.button, midas.buttonSmall, midas.buttonPrimary]
                .filter(val => val)
                .join(' ')}
            >
              {getText('payApply.paymentMethod.updatePage')}
            </button>
          </ButtonGroup>
        }
      />
      <Container>
        <Columns>
          <Column col12 noPadding>
            <LoaderOverlay loading={props.loading}>
              <OngoingPaymentsTable
                hasInvoiceNumber={props.hasInvoiceNumber}
                loadTransactions={props.loadTransactions}
                debitLoading={props.debitLoading}
                debit={props.debit}
                onChangeSize={props.onChangeSize}
                onChangeSortPriority={props.onChangeSortPriority}
                onLoadSearchData={props.onLoadSearchData}
                headers={headers}
                onPrev={props.onPrev}
                onNext={props.onNext}
                users={props.users}
                delayedPaymentAutomaticDebitDateEnabled={
                  props.delayedPaymentAutomaticDebitDateEnabled
                }
                nextRoute={props.nextRoute}
              />
            </LoaderOverlay>
          </Column>
        </Columns>
      </Container>
    </Page>
  )
}

OngoingPaymentsUI.propTypes = {
  loading: PropTypes.bool.isRequired,
  onChangeSortPriority: PropTypes.func.isRequired,
  onPrev: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  onChangeSize: PropTypes.func.isRequired,
  onLoadSearchData: PropTypes.func.isRequired,
  onStatusFilter: PropTypes.func.isRequired,
  onStoreFilter: PropTypes.func.isRequired,
  debit: PropTypes.func.isRequired,
  debitLoading: PropTypes.bool.isRequired,
  loadTransactions: PropTypes.func.isRequired,
  hasInvoiceNumber: PropTypes.bool.isRequired,
  users: PropTypes.object.isRequired,
  stores: PropTypes.array.isRequired,
  delayedPaymentAutomaticDebitDateEnabled: PropTypes.bool.isRequired,
  nextRoute: PropTypes.func.isRequired,
  chainType: PropTypes.string.isRequired,
}

export default searchableTable(pageableTable(OngoingPaymentsUI))
